<template>
  <div class="wrapper">
    <div class="text">
      <h3>{{ $t("pages.other-integrations.subtitle1") }}</h3>
      <p>{{ $t("pages.other-integrations.text1") }}</p>
    </div>
    <div class="integrations">
      <img class="integration-img" src="@/assets/integrations.png" alt="Integrations" />
    </div>
  </div>
</template>

<script>
export default {
  name: "OtherIntegrations",
  components: {},
  data() {
    return {};
  }
};
</script>

<style scoped lang="scss">
@import "../common/_variables.scss";

.wrapper {
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;

}
.text {
  flex: 1 1 0px;
}
.integrations {
  display: flex;
  flex-direction: row;
  justify-content: space-around;
  flex: 2 1 0px;


  .integration-img {
    max-width: 100%;
    margin: 10px 20px;
  }
}

@media only screen and (max-width: $screen-xs) {
  .wrapper {
    flex-direction: column;
    .integrations {
      margin-top: 20px;
    }
  }
}
</style>
